import { render, staticRenderFns } from "./FuncionalidadeHandler.vue?vue&type=template&id=4dbf435a&scoped=true"
import script from "./FuncionalidadeHandler.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf435a",
  null
  
)

export default component.exports